/* ============================================================
   YAMA FUKU MATCHA — main.js
   共通JavaScript：スクロール・モバイルナビ・アニメーション
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. ヘッダー：スクロールでスタイル切替
     ---------------------------------------------------------- */
  const header = document.querySelector('.site-header');

  function updateHeader() {
    if (!header) return;
    const scrolled = window.scrollY > 60;
    header.classList.toggle('site-header--scrolled', scrolled);
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader(); // 初期化

  /* ----------------------------------------------------------
     2. モバイルナビゲーション
     ---------------------------------------------------------- */
  const navToggle = document.querySelector('.nav-toggle');
  const siteNav   = document.querySelector('.site-nav');
  const body      = document.body;

  if (navToggle && siteNav) {
    let savedScrollY = 0;

    function openNav() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      siteNav.classList.add('is-open');
      navToggle.classList.add('is-open');
      // ヘッダーの backdrop-filter を無効化（fixed 子孫の基準化を防ぐ）
      if (header) header.classList.add('site-header--nav-open');
      navToggle.setAttribute('aria-expanded', 'true');
      // iOS Safari では body{overflow:hidden} だけではスクロールを止められないため、
      // 現在位置を保持したまま body を position:fixed で固定する。
      body.style.position = 'fixed';
      body.style.top = '-' + savedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }

    function closeNav() {
      siteNav.classList.remove('is-open');
      navToggle.classList.remove('is-open');
      if (header) header.classList.remove('site-header--nav-open');
      navToggle.setAttribute('aria-expanded', 'false');
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      // 開いた時点のスクロール位置へ戻す
      window.scrollTo(0, savedScrollY);
    }

    navToggle.addEventListener('click', function () {
      if (siteNav.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    // ナビリンクをクリックしたら閉じる
    siteNav.querySelectorAll('.site-nav__link, .site-nav__cta').forEach(link => {
      link.addEventListener('click', () => closeNav());
    });
  }

  /* ----------------------------------------------------------
     3. スクロールリビール（Intersection Observer）
     ---------------------------------------------------------- */
  const revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // 一度だけ
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    revealElements.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     4. アクティブナビリンク（現在ページのマーク）
     ---------------------------------------------------------- */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.site-nav__link').forEach(link => {
    const href = link.getAttribute('href');
    if (href && (href === currentPath || currentPath.startsWith(href) && href !== '/')) {
      link.classList.add('is-active');
    }
  });

  /* ----------------------------------------------------------
     5. スムーススクロール（アンカーリンク）
     ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = parseInt(getComputedStyle(document.documentElement)
        .getPropertyValue('--nav-height')) || 72;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

})();

/* ----------------------------------------------------------
   6. Productsページ フィルタータブ
   ---------------------------------------------------------- */
(function () {
  var tabs  = document.querySelectorAll('.filter-tab');
  var cards = document.querySelectorAll('.product-card');
  if (!tabs.length || !cards.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var filter = tab.getAttribute('data-filter');
      cards.forEach(function (card) {
        var tags = card.getAttribute('data-tags') || '';
        if (filter === 'all' || tags.indexOf(filter) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
})();
